var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrioritySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6435 11.4703C22.567 11.2595 22.3774 11.1108 22.155 11.0889L16.7026 10.5433L14.5235 5.64193C14.4313 5.43271 14.2226 5.29828 13.9948 5.29828C13.767 5.29828 13.5583 5.43271 13.4661 5.64193L11.287 10.5433L5.83478 11.0889C5.61235 11.1108 5.42278 11.2595 5.34608 11.4703C5.2713 11.6805 5.32521 11.9157 5.48348 12.0739L9.31478 15.9066L8.21913 21.3903C8.17391 21.6113 8.26261 21.8385 8.44522 21.9713C8.62626 22.1049 8.86956 22.1195 9.06608 22.0105L13.9948 19.2769L18.9235 22.0105C19.0104 22.059 19.108 22.0828 19.2035 22.0828C19.3235 22.0828 19.4435 22.0454 19.5443 21.9713C19.727 21.8385 19.8156 21.6113 19.7706 21.3903L18.6748 15.9066L22.5061 12.0739C22.6643 11.9157 22.7183 11.6805 22.6435 11.4703Z",
    fill: "#DA291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritySelected);
export default __webpack_public_path__ + "static/media/priority-selected.883b52c1c54400239769cb8ec2503efd.svg";
export { ForwardRef as ReactComponent };